/* eslint-disable camelcase */
export const BOOLEAN_OPTIONS: Record<string, string> = {
  TRUE_VALUE: "true",
  FALSE_VALUE: "false",
};

/*
  Register Form Field Conditions
*/
const FORM_FIELD_CONDITIONS: Record<string, any> = {
  /* Form name */
  "payment-method-and-risk-management": {
    /* Child field that has dependency on other field(s) */
    Has_Insurance_Policy: {
      /* Condition field name and the expected value (in order to show the child field) */
      Wants_Flexport_Insurance: BOOLEAN_OPTIONS.FALSE_VALUE,
    },
  },
  "customs-bond": {
    Products_you_plan_to_import: {
      Has_Customs_Bond: BOOLEAN_OPTIONS.FALSE_VALUE,
    },
    Country_Region_Company_Imports_From: {
      Has_Customs_Bond: BOOLEAN_OPTIONS.FALSE_VALUE,
    },
    Duties_Paid_Over_500K: {
      Has_Customs_Bond: BOOLEAN_OPTIONS.FALSE_VALUE,
    },
    Duties_Paid: {
      Has_Customs_Bond: BOOLEAN_OPTIONS.FALSE_VALUE,
      Duties_Paid_Over_500K: BOOLEAN_OPTIONS.TRUE_VALUE,
    },
    Duties_Expected_Over_500K: {
      Has_Customs_Bond: BOOLEAN_OPTIONS.FALSE_VALUE,
    },
    Duties_Expected: {
      Has_Customs_Bond: BOOLEAN_OPTIONS.FALSE_VALUE,
      Duties_Expected_Over_500K: BOOLEAN_OPTIONS.TRUE_VALUE,
    },
  },
  "capital-inquiry-request-form": {
    state: {
      country: "United States",
    },
  },
  "sign-up": {
    Other_Explanation: {
      How_can_we_help_you: "Other",
    },
  },
  "insurance-2": {
    product_description: {
      insurance_coverage_selection: [
        "free_policy_analysis",
        "per_shipment_coverage",
        "annual_policy_coverage",
        "continuous_entry_bonds",
      ],
    },
    origin_country: {
      insurance_coverage_selection: ["per_shipment_coverage"],
    },
    destination_country: {
      insurance_coverage_selection: ["per_shipment_coverage"],
    },
    estimated_cargo_value: {
      insurance_coverage_selection: ["per_shipment_coverage"],
    },
    freight_forwarder_to_be_used: {
      insurance_coverage_selection: [
        "per_shipment_coverage",
        "annual_policy_coverage",
      ],
    },
    origin_region: {
      insurance_coverage_selection: [
        "free_policy_analysis",
        "annual_policy_coverage",
        "continuous_entry_bonds",
      ],
    },
    destination_region: {
      insurance_coverage_selection: [
        "free_policy_analysis",
        "annual_policy_coverage",
        "continuous_entry_bonds",
      ],
    },
    total_cargo_value_to_be_shipped_next_12_months: {
      insurance_coverage_selection: [
        "free_policy_analysis",
        "annual_policy_coverage",
        "continuous_entry_bonds",
      ],
    },
    total_cargo_value_shipped_last_12_months: {
      insurance_coverage_selection: [
        "free_policy_analysis",
        "annual_policy_coverage",
        "continuous_entry_bonds",
      ],
    },
    average_value_per_conveyance: {
      insurance_coverage_selection: ["continuous_entry_bonds"],
    },
    bond_limit_requested: {
      insurance_coverage_selection: ["continuous_entry_bonds"],
    },
    effective_date_requested: {
      insurance_coverage_selection: ["continuous_entry_bonds"],
    },
    average_cargo_value_per_shipment: {
      insurance_coverage_selection: [
        "free_policy_analysis",
        "annual_policy_coverage",
      ],
    },
    any_particular_concerns: {
      insurance_coverage_selection: ["free_policy_analysis"],
    },
  },
  insurance: {
    product_description: {
      insurance_coverage_selection: [
        "free_policy_analysis",
        "per_shipment_coverage",
        "annual_policy_coverage",
        "continuous_entry_bonds",
      ],
    },
    origin_country: {
      insurance_coverage_selection: ["per_shipment_coverage"],
    },
    destination_country: {
      insurance_coverage_selection: ["per_shipment_coverage"],
    },
    estimated_cargo_value: {
      insurance_coverage_selection: ["per_shipment_coverage"],
    },
    freight_forwarder_to_be_used: {
      insurance_coverage_selection: [
        "per_shipment_coverage",
        "annual_policy_coverage",
      ],
    },
    origin_region: {
      insurance_coverage_selection: [
        "free_policy_analysis",
        "annual_policy_coverage",
        "continuous_entry_bonds",
      ],
    },
    destination_region: {
      insurance_coverage_selection: [
        "free_policy_analysis",
        "annual_policy_coverage",
        "continuous_entry_bonds",
      ],
    },
    total_cargo_value_to_be_shipped_next_12_months: {
      insurance_coverage_selection: [
        "free_policy_analysis",
        "annual_policy_coverage",
        "continuous_entry_bonds",
      ],
    },
    total_cargo_value_shipped_last_12_months: {
      insurance_coverage_selection: [
        "free_policy_analysis",
        "annual_policy_coverage",
        "continuous_entry_bonds",
      ],
    },
    average_value_per_conveyance: {
      insurance_coverage_selection: ["continuous_entry_bonds"],
    },
    bond_limit_requested: {
      insurance_coverage_selection: ["continuous_entry_bonds"],
    },
    effective_date_requested: {
      insurance_coverage_selection: ["continuous_entry_bonds"],
    },
    average_cargo_value_per_shipment: {
      insurance_coverage_selection: [
        "free_policy_analysis",
        "annual_policy_coverage",
      ],
    },
    any_particular_concerns: {
      insurance_coverage_selection: ["free_policy_analysis"],
    },
  },
  "warehouse-tour": {
    warehouse_tour_chicago_timeslots: {
      location: "warehouse-tour-chicago",
    },
    warehouse_tour_los_angeles_timeslots: {
      location: "warehouse-tour-los-angeles",
    },
    warehouse_tour_new_jersey_timeslots: {
      location: "warehouse-tour-new-jersey",
    },
  },
};

/*
  Helper Methods
*/
/**
 *
 * @param {string} formName
 * @return {Array<string>}
 */
export const getChildFields = (formName: string): Array<string> => {
  if (!Object.keys(FORM_FIELD_CONDITIONS).includes(formName)) {
    return [];
  }
  const fields = Object.keys(FORM_FIELD_CONDITIONS[formName]);
  return fields;
};

/**
 *
 * @param {string} formName
 * @return {Record<string, any>}
 */
export const getFormFieldConditions = (
  formName: string
): Record<string, any> => {
  if (!Object.keys(FORM_FIELD_CONDITIONS).includes(formName)) {
    return {};
  }
  return FORM_FIELD_CONDITIONS[formName];
};
